import { Grid, styled } from '@mui/material'
import React from 'react'

const FooterWrapper = styled(Grid)`
    border-top: 1px solid #000;
    padding: 10px 80px;
    background: #1a1998;
    color: #fff;
    
`;

function Footer() {
    return (
        <FooterWrapper container justifyContent={'space-between'} alignItems={'center'}>
            <Grid item xs={3}>
                <h4>Helpline: 9843297486</h4>
            </Grid>
            <Grid item container xs={3} justifyContent={'center'}>
                <p>&copy; RootIt</p>
            </Grid>
        </FooterWrapper>
    )
}

export default Footer